import { render, staticRenderFns } from "./AdminNoveltiesaFilter.vue?vue&type=template&id=e450561a"
import script from "./AdminNoveltiesaFilter.vue?vue&type=script&lang=js"
export * from "./AdminNoveltiesaFilter.vue?vue&type=script&lang=js"
import style0 from "./AdminNoveltiesaFilter.vue?vue&type=style&index=0&id=e450561a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports